module.exports = __webpack_public_path__ + "static/media/disabled_icon.c9d6959b.png";